import angular from 'angular';
import { DAYS_OF_WEEK } from '../../values/days_of_week';
import { groupBy } from 'lodash';

module.exports = angular.module('common.components.human-schedules.show', [
])
.component('odShowHumanAvailabilityGroup', {
  bindings: {
    availability: '<',
    onEdit: '&',
    onDelete: '&',
  },
  template: require('./od-show-availability.jade')(),
  controller: class ShowHumanAvailabilityGroupController {
    // @ngInject
    constructor() {
      this.DAYS_OF_WEEK = DAYS_OF_WEEK;
      this.availabilityByDayOfWeek = groupBy(
        this.availability.availability_windows_attributes, 'day_of_week'
      );
    }
  }
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/human-schedules/od-show-availability.js
 **/